import EventBus from "@/utils/EventBus";
import { API_BASE_URL, API_TIMEOUT } from "@/config/api";
import axios from "axios";
import feedback from "@/services/feedback";
import store from "@/store/index.js";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

const service = axios.create({ baseURL: API_BASE_URL, timeout: API_TIMEOUT });
let loginPromptPromise = null;

const handle401Error = () => {
  if (loginPromptPromise) return loginPromptPromise;
  store.commit("delToken");
  loginPromptPromise = feedback
    .confirm({
      title: "登录状态已失效",
      message: "当前会话已过期或账号安全状态已变更，重新登录后可以继续操作。",
      confirmText: "重新登录",
      cancelText: "暂不登录",
      tone: "warning",
    })
    .then((confirmed) => {
      if (confirmed) {
        EventBus.emit("auth-required", {
          redirect: `${window.location.pathname}${window.location.search}`,
        });
      }
    })
    .finally(() => {
      loginPromptPromise = null;
    });
  return loginPromptPromise;
};

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (config.headers.isToken !== false && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    delete config.headers.isToken;
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  (response) => {
    // 文件流不是统一 Result JSON，直接交给下载调用方。
    if (response.config.responseType === "blob" || response.config.responseType === "arraybuffer") {
      return response;
    }
    const res = response.data;
    if (res.code === 401 || res.code === "401") {
      return handle401Error().then(() => Promise.reject(new Error("AUTH_REQUIRED")));
    }
    if (res.code !== 200) {
      feedback.error({
        title: "请求失败",
        message: res.message || "系统暂时无法完成该操作。",
        duration: 5000,
      });
      return Promise.reject(new Error(res.message || "System error"));
    }
    return res;
  },
  (error) => {
    const { response } = error;
    let message = "系统异常，请稍后重试";
    if (response) {
      switch (response.status) {
        case 401:
          return handle401Error().then(() => Promise.reject(error));
        case 403:
          message = "当前账户没有访问权限";
          break;
        case 404:
          message = "请求的资源不存在";
          break;
        case 500:
          message = "服务器暂时不可用";
          break;
        default:
          message = response.data?.message || "系统异常，请稍后重试";
      }
    }
    feedback.error({ title: "请求失败", message, duration: 5000 });
    return Promise.reject(error);
  }
);

export default service;
